import React from 'react';
import { Switch, Route } from 'react-router-dom';

import * as ROUTES from '../../constants/routes';
import UploadGeneric from './UploadGeneric';

const Upload = () => (
  <div>
    <h1>&nbsp;</h1>

    <Switch>
      <Route exact path={ROUTES.UPLOAD} component={UploadGeneric} />
      <Route exact path={ROUTES.UPLOADACCESSCODE} component={UploadGeneric} />
    </Switch>
  </div>
);

export default Upload;
